/* eslint-disable prettier/prettier */
import { createSlice } from '@reduxjs/toolkit'

const priceReducer = createSlice({
    name: 'priceReducer',
    initialState: {
        priceData: [],
        room:{}
    },
    reducers: {
        setPriceData(state, action) {
            state.priceData = action.payload;
        },
        setRoom(state, action) {
            state.room = action.payload;
        }
    },
})

export const { setPriceData,setRoom } = priceReducer.actions


export default priceReducer.reducer